export const SHOW_EPT_FEATURE_FLAG: string = 'showEasyProvisioningTool'
export const SELF_PROVISIONING_FEATURE_FLAG: string = 'FeatureCapsSelfProvisioning'
export const ENABLE_NEW_USER_EXPERIENCE: string = 'enableNewUserExperience'
export const ENABLE_NEW_INSIGHTS: string = 'enableNewInsights'
export const ENABLE_CRM_TEAMS: string = 'enableCrmTeams'
export const ENABLE_REAL_TIME_QUEUES_MANUAL_MODE: string = 'enableRTQueueManualMode'
export const ENABLE_CLIENT_CONFIGURATION: string = 'enableNewClientConfiguration'
export const ENABLE_CRM_CONFIGURATION: string = 'enableNewCRMConfiguration'
export const ENABLE_GITBOOK_DOC: string = 'enableGitBookDoc'
